export default "__VITE_ASSET__0MN92PXa__"